import { combineReducers } from 'redux'
import * as ActionTypes from '../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_SUCCESS:
            const { organizations } = action.entities
            return { ...state, organizations }
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_SUCCESS:
            return [...action.result]
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_REQUEST:
            return true
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_SUCCESS:
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_FAILURE:
            return action.error
        case ActionTypes.EASYMS_ORGANIZATIONS_FETCH_SUCCESS:
            return null
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/easymsOrganizationsReducer.js